import React, { useEffect, useState } from 'react';
import { get } from '../../utils/network';
import { Route, Redirect } from 'react-router-dom';
import { getCookie, setCookie } from '../../utils/utils'; 
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const ProtectedRoute = ({ exact, path, component, requireDevMode = false }) => {
    const location = useLocation();
    const [devMode, setDevMode] = useState(false);
    const [configLoaded, setConfigLoaded] = useState(false);

      useEffect(() => {
          get('dev/environment')
          .then(res => res.json())
          .then(data => {
            setDevMode(data.message?.DEV_MODE === "true");
            setConfigLoaded(true);
          })
          .catch(err => console.log(err))
      }, [])

    useEffect(() => {
        return () => {
            const isDevRoute = location.pathname.startsWith('/dev');
            const isLogsRoute = location.pathname.includes('/dev/logs');
            const isPublicDevRoute = (isDevRoute && devMode) || isLogsRoute;
            if (!getCookie('isLogged') && !isPublicDevRoute) {
                const redirect = location.pathname + location.search;
                setCookie('loginRedirect', redirect);
            }
        }
    })

    if (!configLoaded) return null;

    const isLogged = getCookie('isLogged');
    const isDevRoute = path.startsWith('/dev');
    const isLogsRoute = location.pathname.includes('/dev/logs');
    
    if (isLogsRoute) {
        return (
            <Route
                exact={exact}
                path={path}
                render={routeProps => {
                    const Component = component;
                    return <Component {...routeProps} devMode={devMode} />;
                }}
            />
        );
    }
    
    if (requireDevMode && !devMode) {
        return <Redirect to="/home" />;
    }
    
    const allowDevAccess = (requireDevMode || isDevRoute) && devMode;
    
    if (!isLogged && !allowDevAccess) {
        return <Redirect from={path} to="/login" exact />
    }
    return (
        <Route
            exact={exact}
            path={path}
            render={routeProps => {
                const Component = component;
                return <Component {...routeProps} devMode={devMode} />;
            }}
        />
    ); };

export default ProtectedRoute;